import { signal } from '@angular/core';
import { ClassicDatasource } from './classic.datasource';

interface HasId {
  id: number;
  [key: string]: any;
}

export abstract class TableDatasource<
  T extends HasId,
  P,
> extends ClassicDatasource<T> {
  abstract defaultSortField: string;
  defaultDescending = false;
  defaultTake = 100;

  searchParams = signal<P | undefined>(undefined);

  async loadData(
    sortField: string | string[] | null | undefined = this.defaultSortField,
    descending = this.defaultDescending,
    skip = 0,
    take = this.defaultTake
  ) {
    return await this.getList({
      filter: JSON.stringify(this.searchParams()),
      sortBy: sortField,
      descending: descending,
      skip: skip,
      take: take,
    });
  }
}
